"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBlipLevelFromChanges = exports.cleanChange = exports.cleanBlip = exports.getUUID = exports.getPseudoRand = exports.getHash = void 0;
var uuid_1 = require("uuid");
// generate hash from string
function getHash(str) {
    var h = 0;
    for (var _i = 0, str_1 = str; _i < str_1.length; _i++) {
        var char = str_1[_i];
        h = ((h << 5) - h) + char.charCodeAt(0);
        h |= 0;
    }
    return h;
}
exports.getHash = getHash;
// create 0..1 pseudo random from string
function getPseudoRand(str) {
    var h = getHash(str);
    // convert signed int32 space to 0..1 float
    return (h + Math.pow(2, 31)) / Math.pow(2, 32);
}
exports.getPseudoRand = getPseudoRand;
function getUUID() {
    return uuid_1.v4();
}
exports.getUUID = getUUID;
// return a new object that only contains the pure blip data
function cleanChange(change) {
    var date = change.date, newLevel = change.newLevel, text = change.text, id = change.id;
    var newChange = { date: date, newLevel: newLevel, text: text, id: id };
    if (!newChange.id)
        delete newChange.id;
    return newChange;
}
exports.cleanChange = cleanChange;
function cleanBlip(blip) {
    var changes = [];
    if (blip.changes) {
        changes = blip.changes.map(cleanChange);
    }
    var category = blip.category, link = blip.link, description = blip.description, title = blip.title, id = blip.id;
    var newBlip = { category: category, link: link, description: description, title: title, changes: changes, id: id };
    if (!link)
        newBlip.link = '';
    else if (!/^https?:\/\//i.test(link))
        newBlip.link = 'https://' + link;
    if (!description)
        newBlip.description = '';
    if (!id)
        newBlip.id = getUUID();
    return newBlip;
}
exports.cleanBlip = cleanBlip;
function addBlipLevelFromChanges(blip) {
    var level = blip.level;
    if (blip.changes.length) {
        level = blip.changes.sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); })[0].newLevel;
    }
    blip.level = level;
    return blip;
}
exports.addBlipLevelFromChanges = addBlipLevelFromChanges;
